import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/homepage'
 */
export const RouteToHomepage = (options?: RouteOptions) => {
  // internally on elysium, HP is on /homepage route. On public there's a url rewrite from / to /homepage
  return RouteBuilder({ ...options, path: '/', target: 'elysium' });
};

export const HomepageConfig: PageConfig = {
  readableName: 'Homepage',
  analyticsGaName: 'homepage',
  analyticsAthenaName: 'homepage',
  pagePathnames: ['/homepage'],
  displayPromoBar: true,
  defaultMeta: {
    title: 'Displate – metal posters | Change your wall, change your world',
    description:
      'Wall art built to last forever. Official designs from Star Wars&trade;, Marvel, Netflix and 200+ more brands. Hassle-free magnet mounting. 100% made in the EU.',
    coverImage: StaticImage('/images/homepage/preview.webp'),
  },
};

export const HpHeaderHeights = {
  desktop: 162,
  mobile: 162,
};
